import { Injectable } from '@angular/core';
import { BaseService } from '../base/base.service';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { tablecategorycreateRq } from '../../../interfaces/rq-rs/rq-rs-table-category.interface';
import { MenuInterface } from '../../../interfaces/user.interface';
@Injectable({
  providedIn: 'root',
})
export class TableCategoryService extends BaseService {
  constructor(private http: HttpClient) {
    super();
  }

  list(params: any) {
    const URL = `${this.baseUrl}TableCategory/GetCategoriesForPermission`;
    return this.http.get<any>(URL, { headers: this.headers, params: params }).pipe(
      map((r) => {
        return r.result;
      }),
    );
  }

  create(body: tablecategorycreateRq) {
    const URL = `${this.baseUrl}TableCategory/CreateOrUpdate`;
    return this.http.post<any>(URL, body, { headers: { 'Content-Type': 'application/json' } }).pipe(
      map((r) => {
        return r.result;
      }),
    );
  }

  info(id: number): Observable<any> {
    const URL = `${this.baseUrl}TableCategory/GetForEdit`;
    return this.http.get<any>(URL, { params: { id: id }, headers: this.headers }).pipe(
      map((r) => {
        return r.result;
      }),
    );
  }

  delete(id: number) {
    const URL = `${this.baseUrl}TableCategory/Delete`;
    return this.http.delete<any>(URL, { params: { id: id }, headers: this.headers }).pipe(
      map((r) => {
        return r.result;
      }),
    );
  }

  all() {
    const URL = `${this.baseUrl}TableCategory/GetCategoriesForDropdown`;
    return this.http.get<any>(URL, { headers: this.headers }).pipe(
      map((r) => {
        return r.result;
      }),
    );
  }
  menu(userId: string): Observable<MenuInterface[]> {
    const URL = `${this.baseUrl}TableCategory/GetAllMenuItems`;
    return this.http
      .get<{ result: MenuInterface[] }>(URL, {
        headers: this.headers,
        params: { userId },
      })
      .pipe(map((response) => response.result || []));
  }
}
